













































































import { InfoTypeHelper } from "@/common/models";
import { SharedState } from "@/common/state";
import Spinner from "@/components/Spinner.vue";
import { computed } from "@vue/composition-api";
import Vue from "vue";
import { state } from "./state";
export default Vue.extend({
  components: { Spinner },
  setup(_, { emit }) {
    const { is_loading, regulated_items } = state;
    const DISPLAY_ITEMS_IN_EACH_COL = 6;

    const show_more = () =>
      emit(
        "show_more",
        SharedState.allInfoTypes.value[InfoTypeHelper.REGULATED_ID()]
      );

    const on_item_clicked = (item: any) => emit("item_clicked", item);

    const more_count = computed(() => {
      const total = regulated_items.value.reduce((acc, [_, items]) => {
        acc += items.filter((d: { count: number }) => d.count > 0).length;
        return acc;
      }, 0);
      const more = total - DISPLAY_ITEMS_IN_EACH_COL * 4; /* NUM OF COLS */
      return more;
    });

    return {
      is_loading,
      regulated_items: computed(() => {
        if (SharedState.data_sources_includes_ms.value) {
          return regulated_items.value;
        } else {
          const personal_info_id = InfoTypeHelper.REGULATED_CODE();
          return regulated_items.value.filter(
            ([code]) => code !== personal_info_id
          );
        }
      }),
      show_more,
      more_count,
      on_item_clicked,
      should_display_ms_labels_section:
        SharedState.data_sources_includes_ms.value,
    };
  },
});
